import "../../data/style/keyframes.css";
import { Theme } from "../../data/style/Theme";
import useScreenSize from "../../context/ScreenContext";
import { AllCenteredColumn } from "../../data/style/Style";

const StatPanel = ({ text, subText, count }) => {
  const { mobileDevice } = useScreenSize();
  return (
    <AllCenteredColumn
      gap={1}
      sx={{
        background: Theme.palette.card,
        borderRadius: 3,
        border: `1px solid ${Theme.palette.border}`,
        padding: mobileDevice ? "8px" : "16px",
        flex: 1,
      }}
    >
      <div
        className="countUp"
        style={{
          fontFamily: "Oswald, sans-serif",
          fontWeight: mobileDevice ? 800 : 900,
          fontSize: mobileDevice ? "1rem" : "clamp(22px,3vw,30px)",
          color: Theme.palette.orange,
          lineHeight: 1,
        }}
      >
        {count !== 0 ? count : "None"}
      </div>
      <div
        style={{
          fontFamily: "DM Sans, sans-serif",
          fontSize: mobileDevice ? "0.6rem" : "0.9rem",
          color: Theme.palette.textSub,
          lineHeight: 1.4,
          whiteSpace: "pre-line",
          height: mobileDevice && "25px",
        }}
      >
        {text} {subText}
      </div>
    </AllCenteredColumn>
  );
};

export default StatPanel;
